import { queryGraphQL,mutateGraphQL } from 'complionUtil/query';
import { toMutation, toQuery, nodeWithArgs } from 'complionUtil/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import lodash from 'lodash';

export const LOAD_STUDY_ROLES_V2 = 'LOAD_STUDY_ROLES_V2';
export const ADD_STUDY_ROLE_V2 = 'ADD_STUDY_ROLE_V2';

export function loadStudyRolesV2(institutionId) {
    return (dispatch, setState) => {
        const query = nodeWithArgs('rolesManagementForInstitution', {
            institutionId,
        }, [
            'id',
            'name',
            'isSystem'
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve roles for institution'));
            } else {
                const doaRoles = results.data.rolesManagementForInstitution;
                const nonSystemRoles = lodash
                    .filter(doaRoles, role => role.isSystem === false)
                    .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
                const systemRoles = lodash
                    .filter(doaRoles, role => role.isSystem === true)
                    .sort((role1, role2) => lodash.get(role1, 'name', '').localeCompare(lodash.get(role2, 'name', '')));
                const newDoaRoles = lodash.concat(systemRoles, nonSystemRoles);

                dispatch({
                    type: LOAD_STUDY_ROLES_V2,
                    payload: newDoaRoles,
                });
            }    
        });
    };
}

export function addStudyRoleV2(institutionId, name) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('createRolesManagement', {
            institutionId,
            name
        }, [
            'id',
            'name',
            'isSystem',
        ]);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to add role to institution'));
            } else {
                dispatch({
                    type: ADD_STUDY_ROLE_V2,
                    payload: results.data.createRolesManagement,
                });
            }
        });
    };
}
